<template>
  <div class="step-path" :class="['step-path--' + boatStep, 'step-state--' + step]">
    <template v-if="!isMobile">
      <svg class="path-active" viewBox="0 0 898 292">
        <path stroke="#F9BA09" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round" d="M8,136 C8,136 142.878,14.74 267,63 C63.582,118.614 165.594,271.41 171,279 C176.406,286.59 279.354,154.019 385,271 C340.719,160.986 415.991,33.897 522,74 C613.622,30.114 651.838,258.383 664,274 C676.162,289.617 668.325,-73.608 890,16"></path>
      </svg>
    </template>
    <template v-else>
      <svg class="path-mobile" viewBox="0 0 187.76 365.76">
        <path fill="none" stroke="#FFF" stroke-dasharray="10.04 5.02" stroke-linecap="round" stroke-width="2.51" d="M11.26 14.26c26.9-17.47 132.32-22.31 171 36-29.54-8.71-75.84 12.97-110 77 20.8 34.27 10.08 67.4-50 98 10.52 4.75 66.08-54.88 149 6-26.77-2.11-124.63 17.27-167 101 41.62-17.1 125.5-37.06 177 29"/>
      </svg>
      <svg class="path-active" viewBox="0 0 187.76 365.76">
        <path stroke="#F9BA09" stroke-width="2.51" fill="none" stroke-linecap="round" stroke-linejoin="round" d="M11.26 14.26c26.9-17.47 132.32-22.31 171 36-29.54-8.71-75.84 12.97-110 77 20.8 34.27 10.08 67.4-50 98 10.52 4.75 66.08-54.88 149 6-26.77-2.11-124.63 17.27-167 101 41.62-17.1 125.5-37.06 177 29"></path>
      </svg>
    </template>
    <div class="boat" :class="boatClasses">
      <div class="boat-wrapper">
        <div class="waves" :class="{ 'waves--moving': moving }">
          <img class="waves_back w1" src="@/assets/boat/waves_back.png">
          <img class="waves_back w2" src="@/assets/boat/waves_back.png">
          <img class="waves_back w3" src="@/assets/boat/waves_back.png">
          <img class="waves_top w1" src="@/assets/boat/waves_top.png">
          <img class="waves_top w2" src="@/assets/boat/waves_top.png">
          <img class="waves_top w3" src="@/assets/boat/waves_top.png">
        </div>
        <img class="item" src="@/assets/boat/boat.png">
      </div>
    </div>
    <div
      v-for="(point, idx) in points"
      :key="point.step"
      class="point"
      :class="pointClass(point, idx)"
      @click="goToStep(point, idx)"
    >
      <span>{{ point.name }}</span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: ['step'],
  data () {
    return {
      boatStep: 'start',
      fromStep: 'start',
      moving: true
    }
  },
  computed: {
    ...mapState({
      points: state => state.steps
    }),
    boatClasses () {
      return {
        ['boat--' + this.boatStep]: this.boatStep,
        ['boat--from-' + this.fromStep + '-to-' + this.boatStep]: this.boatStep,
        'boat--moving': this.moving
      }
    },
    currentIndex () {
      return this.points.findIndex(el => el.step === this.boatStep)
    }
  },
  watch: {
    step () {
      const stepIndex = this.points.findIndex(el => el.step === this.step)
      if (stepIndex >= this.currentIndex) {
        this.fromStep = this.boatStep
        this.boatStep = this.step
      }
    },
    boatStep (_new, _old) {
      setTimeout(() => {
        this.moving = true
      }, 50)
      setTimeout(() => {
        this.moving = false
        this.fromStep = null
      }, 1300)
    }
  },
  methods: {
    pointClass (point, idx) {
      return {
        ['point--' + point.step]: !!point.step,
        'point--old': idx <= this.currentIndex
      }
    },
    goToStep (point, idx) {
      const stepIndex = this.points.findIndex(el => el.step === point.step)
      if (stepIndex - this.currentIndex < 2) {
        this.$emit('step', point.step)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .step-path {
    overflow: hidden;

    &.step-state--start {
      opacity: 0;
      pointer-events: none;
    }
    &.step-state--path {
      transition: opacity .3s;
    }

    &:before {
      content: '';
      position: absolute;
      left: 10%;
      right: 10%;
      top: 0;
      bottom: 0;
      background: url(../assets/path.png) no-repeat center 40%;
      background-size: contain;

      @include media-down(md) {
        display: none;
      }
    }
  }
  .path-mobile {
    position: absolute;
    width: 70%;
    left: 15%;
    top: 52%;
    transform: translate(0, -50%);
    height: auto;
  }
  .path-active {
    position: absolute;
    width: 80%;
    left: 10%;
    top: 45.5%;
    transform: translate(0, -50%);
    height: auto;
    stroke-dasharray: 2000;
    stroke-dashoffset: 2000;
    transition: stroke-dashoffset .36s;

    @include media-down(md) {
      width: 70%;
      left: 15%;
      top: 52%;
    }

    .step-path--clarification & {
      stroke-dashoffset: 1720;

      @include media-down(md) {
        stroke-dashoffset: 1815;
      }
    }
    .step-path--syndromes & {
      stroke-dashoffset: 1430;

      @include media-down(md) {
        stroke-dashoffset: 1670;
      }
    }
    .step-path--examination & {
      stroke-dashoffset: 1180;

      @include media-down(md) {
        stroke-dashoffset: 1535;
      }
    }
    .step-path--diagnosis & {
      stroke-dashoffset: 880;

      @include media-down(md) {
        stroke-dashoffset: 1385;
      }
    }
    .step-path--treatment & {
      stroke-dashoffset: 600;

      @include media-down(md) {
        stroke-dashoffset: 1175;
      }
    }
    .step-path--repeated & {
      stroke-dashoffset: 0;

      @include media-down(md) {
        stroke-dashoffset: 950;
      }
    }
  }
  .point {
    position: absolute;
    transform: translate(-50%, 0);
    counter-increment: point;
    cursor: pointer;

    &:before {
      content: counter(point);
      position: absolute;
      background: url(../assets/pin.png) no-repeat center center;
      background-size: 100% 100%;
      width: 42px;
      height: 62px;
      bottom: 0;
      left: 50%;
      transform: translate(-50%, 0);
      color: #006490;
      font-size: 26px;
      font-weight: bold;
      text-align: center;
      padding: 5px 0 0;
      z-index: 2;

      @include media-down(md) {
        width: 32px;
        height: 47px;
        font-size: 20px;
        padding: 2px 0 0;
      }
    }
    span {
      font-size: 16px;
      line-height: 1;
      text-align: center;
      font-weight: bold;
      color: #fff;
      position: absolute;
      top: -3px;
      left: 50%;
      transform: translate(-50%, 0);
      padding: 6px 15px;
      background: linear-gradient(to bottom, #033972, #000c2b);
      transition: all .3s;

      @include media-down(md) {
        top: auto !important;
        bottom: 46px !important;
        font-size: 14px;
        padding: 3px 10px;
      }
    }

    &--old {
      &:before {
        background: url(../assets/pin-active.png) no-repeat center center;
        width: 26px;
        height: 42px;
        color: #0098db;
        font-size: 16px;
        padding: 3px 0 0;
      }

      span {
        background: linear-gradient(to bottom, #00b7e8, #0077cc);
      }

      @include media-down(md) {
        span {
          transform: translate(-50%, 8px) !important;
        }
      }
    }

    &--anamnesis {
      left: 10%;
      bottom: 55%;

      span {
        top: auto;
        bottom: 60px;
      }

      @include media-down(md) {
        bottom: 86%;
        left: 20%;
      }
    }
    &--anamnesis.point--old {
      span {
        transform: translate(-50%, 20px);
      }
    }
    &--clarification {
      left: 34%;
      bottom: 69%;

      span {
        top: auto;
        bottom: 60px;
      }

      @include media-down(md) {
        bottom: 77%;
        left: 84%;
      }
    }

    &--clarification.point--old {
      span {
        transform: translate(-50%, 20px);
      }
    }
    &--syndromes {
      left: 25.2%;
      bottom: 29%;

      @include media-down(md) {
        bottom: 60%;
        left: 42%;
      }
    }
    &--examination {
      left: 44.3%;
      bottom: 31%;

      @include media-down(md) {
        bottom: 38%;
        left: 23%;

        span {
          top: auto;
          bottom: 60px;
        }
      }
    }
    &--diagnosis {
      left: 56.5%;
      bottom: 67%;

      span {
        top: auto;
        bottom: 60px;
      }

      @include media-down(md) {
        bottom: 36%;
        left: 80%;
      }
    }
    &--diagnosis.point--old {
      span {
        transform: translate(-50%, 20px);
      }
    }
    &--treatment {
      left: 69.2%;
      bottom: 30%;

      @include media-down(md) {
        bottom: 13%;
        left: 17%;
      }
    }
    &--repeated {
      left: 89%;
      bottom: 78%;

      @include media-down(md) {
        bottom: 6%;
        left: 83%;
      }
    }
  }
</style>

<style lang="scss" scoped>
.waves {
  @keyframes ship_top {
    0%{
      transform: scaleX(1) scaleY(1);
      opacity: 0.5;
    }
    60%{
      transform: scaleX(1.1) scaleY(1.3);
      opacity: 0.5;
    }
    100%{
      transform: scaleX(1.1) scaleY(1.5);
      opacity: 0;
    }
  }
  @keyframes ship_back {
    0%{
      transform: scaleY(0.3);
      opacity: 0.5;
    }
    50%{
      transform: scaleY(1);
      opacity: 0.5;
    }
    100%{
      transform: scaleY(2);
      opacity: 0;
    }
  }
  position: absolute;
  transform: scale(1, .7) rotate(75deg);
  transform-origin: 0 50%;
  width: 25%;
  right: -20%;
  top: 20%;
  transition: all .4s;
  opacity: 0;

  &--moving {
    opacity: 1;
  }

  .waves_top {
    position: absolute;
    transform-origin: top center;

    &.w1 {
      animation: ship_top 1s linear 0s infinite;
    }
    &.w2 {
      animation: ship_top 1s linear 1s infinite;
    }
  }
  .waves_back {
    position: absolute;
    transform-origin: top center;
    opacity: 0;

    &.w1 {
      animation: ship_back 3s linear 0s infinite;
    }
    &.w2 {
      animation: ship_back 3s linear 1.5s infinite;
    }
    &.w3 {
      animation: ship_back 3s linear 3s infinite;
    }
  }

  img {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: auto;
  }
}

.boat {
  position: absolute;
  left: -25%;
  top: 40%;
  width: 25%;
  height: auto;
  pointer-events: none;

  @include media-down(md) {
    transform: translate(-20%, 0) rotate(0deg);
  }

  .item {
    position: relative;
  }

  img {
    width: 100%;
    display: block;
  }

  @include media-down(md) {
    width: 45%;
    top: 12%;
    left: -40%;
  }
}
.boat {
  &--path,
  &--anamnesis,
  &--from-start-to-path {
    transition: transform 1s;
    transform: translate(60%, -15%) rotate(0deg);
  }
  &--from-start-to-start,
  &--fromt-repeated-to-path {
    transform: translate(60%, -15%) rotate(0deg);
  }

  &--clarification {
    transform-origin: 13% 98%;
    transform: translate(210%, -53%) rotate(-9deg);

    .boat-wrapper {
      transform: scale(-1, 1);
    }

    @include media-down(md) {
      transform-origin: 10% 200%;
      transform: translate(260%, 30%) rotate(-10deg);
    }
  }

  &--from-anamnesis-to-clarification {
    transition: transform 1s;
    transform-origin: 190% 300%;
    transform: translate(60%, -15%) rotate(25deg);

    .boat-wrapper {
      transform: scale(1, 1);
    }

    @include media-down(md) {
      transform-origin: 170% 300%;
      transform: translate(60%, 30%) rotate(35deg);

      .boat-wrapper {
        transform: scale(1, 1);
      }
    }
  }

  &--syndromes {
    transform: translate(140%, 70%) rotate(3deg);

    @include media-down(md) {
      transform-origin: 10% 200%;
      transform: translate(260%, 30%) rotate(-60deg);

      .boat-wrapper {
        transform: scale(-1, 1);
      }
    }
  }

  &--from-clarification-to-syndromes {
    transition: transform 1s;
    transform-origin: 13% 98%;
    transform: translate(210%, -23%) rotate(-180deg);

    .boat-wrapper {
      transform: scale(-1, -1);
      transition: all 0s ease .45s;
    }

    @include media-down(md) {
      transform-origin: 10% 200%;
      transform: translate(260%, 30%) rotate(-60deg);

      .boat-wrapper {
        transform: scale(-1, 1);
      }
    }
  }
  &--examination {
    transform-origin: -100% -70%;
    transform: translate(205%, 88%) rotate(-5deg);

    @include media-down(md) {
      transform-origin: 113% 350%;
      transform: translate(50%, 230%) rotate(5deg);

      .boat-wrapper {
        transform: scale(1, 1);
      }
    }
  }
  &--from-syndromes-to-examination {
    transform-origin: 50% 50%;
    transform: translate(205%, 67%) rotate(-5deg);
    transition: transform 1s;

    @include media-down(md) {
      transform-origin: 10% 200%;
      transform: translate(251%, 30%) rotate(-95deg);

      .boat-wrapper {
        transform: scale(-1, 1);
      }
    }
  }
  &--diagnosis {
    transform-origin: 0% 200%;
    transform: translate(209%, -115%) rotate(30deg);

    @include media-down(md) {
      transform-origin: 0% 230%;
      transform: translate(250%, 241%) rotate(-5deg);

      .boat-wrapper {
        transform: scale(-1, 1);
      }
    }
  }
  &--from-examination-to-diagnosis {
    transition: transform 1s;
    transform-origin: -100% -70%;
    transform: translate(230%, 35%) rotate(-19deg);

    .boat-wrapper {
      transition: transform .3s;
      transform: rotate(-20deg);
    }

    @include media-down(md) {
      transform-origin: 113% 350%;
      transform: translate(50%, 220%) rotate(35deg);

      .boat-wrapper {
        transform: rotate(0);
      }
    }
  }
  &--treatment {
    transform-origin: 0 -200%;
    transform: translate(290%, 80%) rotate(-5deg);

    @include media-down(md) {
      transform-origin: 100% 380%;
      transform: translate(60%, 350%) rotate(1deg);

      .boat-wrapper {
        transform: scale(1, 1);
      }
    }
  }
  &--from-diagnosis-to-treatment {
    transition: transform 1s;
    transform-origin: 0% 200%;
    transform: translate(229%, -115%) rotate(60deg);

    .boat-wrapper {
      transition: transform 1s;
      transform: rotate(10deg);
    }

    @include media-down(md) {
      transform-origin: 0% 230%;
      transform: translate(250%, 255%) rotate(-60deg);

      .boat-wrapper {
        transition: none;
        transform: scale(-1, 1);
      }
    }
  }
  &--repeated {
    z-index: 2;
    transform: translate(370%, -65%) rotate(12deg);

    @include media-down(md) {
      transform-origin: 100% 380%;
      transform: translate(60%, 350%) rotate(30deg);
    }
  }
  &--from-treatment-to-repeated {
    transform-origin: 0 -200%;
    transition: transform 1s;
    transform: translate(290%, 80%) rotate(-40deg);

    @include media-down(md) {
      transform-origin: 100% 380%;
      transform: translate(60%, 350%) rotate(30deg);

      .boat-wrapper {
        transform: scale(1, 1);
      }
    }
  }
}
</style>
